import { Component, OnInit, inject, DestroyRef, input, Input } from '@angular/core';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { translate } from '@jsverse/transloco';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidenavCustomImageComponent } from '../sidenav-custom-image/sidenav-custom-image.component';

@Component({
  selector: 'app-tenant-custom-image-details',
  templateUrl: './tenant-custom-image-details.component.html',
  styleUrl: './tenant-custom-image-details.component.scss',
  providers: [TitleCasePipe],
  standalone: false
})
export class TenantCustomImageDetailsComponent implements OnInit{
  private destroyRef = inject(DestroyRef);
  RouterSegments = RouterSegments;
  breadcrumbItems: BreadcrumbItem[] = [];
  tenantId: any;
  customImageId: any;
  solutionId: string;
  solutionName: string;
  customImage: any;
  showLoader = true;
  referencesList: any[] = [];


  constructor( private solutionsService: SolutionsService, private activatedRoute: ActivatedRoute, private router: Router,
    private toastrService: CustomToastrService, public datePipe: DatePipe, private dialog: MatDialog, public authService: AuthService, private sidenavService: SidenavService, private titleCasePipe: TitleCasePipe) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.solutionId = params['solutionId'];
      this.solutionName = params['solutionName'];
    });
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.customImageId = this.activatedRoute.snapshot.params['custom-imageId'];
    this.breadcrumbItems.push({ label: 'Home', url: [RouterSegments.TENANT, this.tenantId] });
    this.breadcrumbItems.push({label: translate('INSTANCE_DETAILS.CUSTOM_PACKAGE'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.CUSTOM_IMAGE]});
    this.breadcrumbItems.push({label: this.solutionName, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.CUSTOM_IMAGE],
      queryParams: {
        solutionId: this.solutionId,
        solutionName: this.solutionName
      }
    });
    this.getCustomImageDetailsById();
}

/* Fetches the details of a specific Custom Image by ID */
getCustomImageDetailsById() {
  this.showLoader = true;
  this.solutionsService.getReferencePackagesById(this.solutionId, this.customImageId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(
      (data) => {
      this.customImage = data;
      this.breadcrumbItems.push({ label: this.customImage.name});
      this.referencesList = this.customImage?.references?.map(ref => ({
      component: ref.component,
      images: ref.images || [],
      packages: ref.packages || []
    })) || [];
        this.showLoader = false;
      },
      (error) => {
        this.showLoader = false;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      }
    );
  }

  /* displays the JSON view for the selected Custom Image. */
  viewJson() {
     if (this.referencesList?.length) {
      this.sidenavService.openInRightSidenav(SidenavCustomImageComponent, {
        data: this.referencesList,
        subtitle: this.customImage.name,
        title: translate('CUSTOM_IMAGES.VIEW_JSON'),
      });
    }
  }
}